"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAddressMandatoryToGenerateReceipt = exports.askForRegion = exports.mustDisplayAddressQuestion = exports.isAddressMandatory = exports.ticketingAskForAddress = exports.donationFormAskForAddress = void 0;
const country_1 = require("../enums/country");
const receipt_1 = require("./receipt");
const formAskForAddress = (country, { formGenerateReceipt, askForAddress }) => {
    if (country === country_1.OrganizationCountry.UnitedStates) {
        return Boolean(askForAddress);
    }
    if (country === country_1.OrganizationCountry.Canada ||
        country === country_1.OrganizationCountry.Australia ||
        country === country_1.OrganizationCountry.Germany) {
        if (formGenerateReceipt) {
            return true;
        }
        else {
            return askForAddress;
        }
    }
    if (country === country_1.OrganizationCountry.GreatBritain) {
        return Boolean(askForAddress);
    }
    return askForAddress;
};
const donationFormAskForAddress = (donationForm, organization) => {
    const formGenerateReceipt = (0, receipt_1.donationFormCanGenerateReceipt)(donationForm, organization);
    return formAskForAddress(organization.country, { formGenerateReceipt, askForAddress: donationForm.askForAddress });
};
exports.donationFormAskForAddress = donationFormAskForAddress;
const ticketingAskForAddress = (ticketing, rates, organization) => {
    const formGenerateReceipt = (0, receipt_1.ticketingCanGenerateReceipt)(ticketing, rates, organization);
    return formAskForAddress(organization.country, { formGenerateReceipt, askForAddress: ticketing.askForAddress });
};
exports.ticketingAskForAddress = ticketingAskForAddress;
const isAddressMandatory = (organization, formHasReceipt) => {
    // If the organization can generate receipts and receipts are enabled on the form, we need to ask for the address
    if (organization?.country === country_1.OrganizationCountry.Canada ||
        organization?.country === country_1.OrganizationCountry.Australia ||
        organization?.country === country_1.OrganizationCountry.Germany) {
        return Boolean(organization?.canGenerateReceipt && formHasReceipt);
    }
    // GB: If the organization has a connected Swiftaid account, we need to ask for the address
    if (organization?.country === country_1.OrganizationCountry.GreatBritain) {
        return Boolean(organization?.hasConnectedSwiftaidAtUtc);
    }
    return false;
};
exports.isAddressMandatory = isAddressMandatory;
const mustDisplayAddressQuestion = ({ displayGenerateReceipt, organization, hasGiftAidConfirmation, formData, }) => {
    // If the organization can generate receipts and receipts are enabled on the form, we need to ask for the address
    if (organization?.country === country_1.OrganizationCountry.Canada ||
        organization?.country === country_1.OrganizationCountry.Australia ||
        organization?.country === country_1.OrganizationCountry.Germany) {
        if (displayGenerateReceipt) {
            return true;
        }
        return Boolean(formData.askForAddress);
    }
    // GB: If the organization has a connected Swiftaid account, we need to ask for the address
    if (organization?.country === country_1.OrganizationCountry.GreatBritain) {
        if (hasGiftAidConfirmation) {
            return true;
        }
        return Boolean(formData.askForAddress);
    }
    if (organization?.country === country_1.OrganizationCountry.UnitedStates ||
        organization?.country === country_1.OrganizationCountry.Ireland) {
        return Boolean(formData.askForAddress);
    }
    return false;
};
exports.mustDisplayAddressQuestion = mustDisplayAddressQuestion;
const askForRegion = (country) => {
    return (country === country_1.OrganizationCountry.UnitedStates ||
        country === country_1.OrganizationCountry.Canada ||
        country === country_1.OrganizationCountry.Australia);
};
exports.askForRegion = askForRegion;
const isAddressMandatoryToGenerateReceipt = (country) => {
    return (country === country_1.OrganizationCountry.Canada ||
        country === country_1.OrganizationCountry.Australia ||
        country === country_1.OrganizationCountry.Germany);
};
exports.isAddressMandatoryToGenerateReceipt = isAddressMandatoryToGenerateReceipt;
